import React from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import ErrorAlert from "../../ErrorAlert/index.js";
import NotAvailableIllustration from "../../../../assets/illustrations/not-available.svg";
import { FLIGHT_DETAILS_RETRYABLE_ERROR_CODES } from "../../../../constants.js";
export default function FlightDetailsErrorMobile(props) {
    const { onErrorClose, onClose, flightDetailsError } = props;
    const i18n = useI18n();
    return (React.createElement(ErrorAlert, { illustration: React.createElement(NotAvailableIllustration, null), title: i18n.trans(t("flights_error_unavailable")), body: i18n.trans(t("flights_error_unavailable_body")), buttonLabel: i18n.trans(t("flights_search_action")), onClick: () => {
            if (onErrorClose) {
                onErrorClose();
                return;
            }
            const errorDoesNotNeedReload = FLIGHT_DETAILS_RETRYABLE_ERROR_CODES.includes(flightDetailsError?.code || "");
            onClose({ forceReload: !errorDoesNotNeedReload });
        } }));
}
